export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    // { label: "商品分类", prop: "productCategory", slots: "productCategory", width: 150 },
    // { label: "所属门店", prop: "store_id", slots: "store_id" },
    { label: "商品ID", prop: "id", width: 80 },
    { label: "商品编码", prop: "productCode", width: 180 },
    { label: "产品名", prop: "productName" },
    { label: "前台价", prop: "marketPrice", width: 130, width: 80 },
    { label: "折扣价", prop: "price", width: 130, width: 80 },
    { label: "成本价", prop: "costPrice", width: 130, width: 80 },
    { label: "状态", prop: "status", slots: "status", width: 80 },
    { label: "商品规格", prop: "isSku", slots: "isSku", width: 80 },
    {
      label: "创建时间",
      prop: "createTime",
      width: 180,
      // slots: "state",
    },
    {
      label: "操作",
      prop: "operation",
      width: 180,
      slots: "operation",
      // fixed: "right",
    },
  ];
}
